/*
 * @Author: freedeng
 * @Date: 2019-07-09 11:20:29
 * @Last Modified by: freedeng
 * @Last Modified time: 2019-07-09 15:39:49
 */
var DBDriver;
(function (DBDriver) {
    DBDriver[DBDriver["ClientDB"] = 0] = "ClientDB";
    DBDriver[DBDriver["IndexDB"] = 1] = "IndexDB";
})(DBDriver || (DBDriver = {}));
export { DBDriver };
//# sourceMappingURL=Interface.js.map